import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../../Context/LangContext";
import "./Features.css";
import { FEATURES, baseURL } from "../../../Api/Api";
import axios from "axios";

function SubFeatures(props) {
  return (
    <Col lg={4} md={6}>
      <div className="sub-features" key={props.key}>
        <div className="img-features">
          <img src={props.img} alt={props.name} />
        </div>
        <div className="text-features">
          <h2> {props.name}</h2>
          <p> {props.dis}</p>
        </div>
      </div>
    </Col>
  );
}
export default function Features() {
  const langCtx = useContext(LangContext);
  const [dataFeatures, setDataFeatures] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}/${FEATURES}`, {
        headers: {
          Accept: "application/json",
          "Accept-Language": `${langCtx}`,
        },
      })
      .then((res) => setDataFeatures(res.data.data));
  }, [langCtx]);

  const taFeatures = dataFeatures.map((item) => {
  return  <SubFeatures key={item.id} img={item.photo} name={item.name} dis={item.desc} />;
  });

  console.log(taFeatures);
  return (
    <section className="features pg-section mr-section" id="features">
      <div className="main-container">
        <Row className="align-items-baseline">
          <Col lg={3}>
            <div className="title-features">
              <h2> {text.titlefeatures[langCtx]}</h2>
              <img src="/images/bg-arrow.png" alt="arrow" />
            </div>
          </Col>

          <Col lg={9}>
            <Row className="pg-none row-gap-3">{taFeatures}</Row>
          </Col>
        </Row>
      </div>
    </section>
  );
}

const text = {
  titlefeatures: {
    ar: "مميزات التطبيق ",
    en: "Application features",
  },
};
